"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefreshableViewComponentManager = void 0;
var RefreshableViewComponentManager = (function () {
    function RefreshableViewComponentManager() {
    }
    return RefreshableViewComponentManager;
}());
exports.RefreshableViewComponentManager = RefreshableViewComponentManager;
